@switch (module) {
  @case (modules.Alerts) {
    <!-- ALERTS related template -->
    <app-alert-template [columnName]="columnName" [element]="element"></app-alert-template>
  }
  @case (modules.Certificate) {
    <!-- Certificates related template -->
    <app-certificate-template
      [columnName]="columnName"
      [element]="element"
    ></app-certificate-template>
  }
  @case (modules.Certificates) {
    <!-- CERTIFICATE related template -->
    <app-certificate-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-certificate-templates>
  }
  @case (modules.Competence) {
    <!-- COMPETENCE related template -->
    <app-competence-template
      [columnName]="columnName"
      [element]="element"
      [urlForRouting]="urlForRouting"
    ></app-competence-template>
  }
  @case (modules.CrewManagement) {
    <!-- CREW-MANAGEMENT related template -->
    <app-crew-management-template
      [columnName]="columnName"
      [element]="element"
    ></app-crew-management-template>
  }
  @case (modules.Departments) {
    <!-- DEPARTMENT related templates -->
    <app-departments-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
      [hideButtons]="hideButtons"
    ></app-departments-templates>
  }
  @case (modules.Documents) {
    <ng-container *ngTemplateOutlet="documentTemplates"></ng-container>
  }
  @case (modules.Document) {
    <ng-container *ngTemplateOutlet="documentTemplates"></ng-container>
  }
  @case (modules.Drills) {
    <app-drills-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
    ></app-drills-templates>
  }
  @case (modules.Checklist) {
    <app-task-template
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
    ></app-task-template>
  }
  @case (modules.FormsLibrary) {
    <!-- FORMS LIBRARY related template -->
    <app-forms-library-template
      [columnName]="columnName"
      [element]="element"
    ></app-forms-library-template>
  }
  @case (modules.NonConformances) {
    <!-- NON-CONFORMANCES related template -->
    <app-non-conformance-template
      [columnName]="columnName"
      [element]="element"
    ></app-non-conformance-template>
  }
  @case (modules.NonConformance) {
    <!-- NON-CONFORMANCE related template -->
    <app-non-conformance-template
      [columnName]="columnName"
      [element]="element"
    ></app-non-conformance-template>
  }
  @case (modules.Maintenance) {
    <!-- MAINTENANCE related template -->
    <app-maintenance-templates
      [columnName]="columnName"
      [element]="element"
      [specificTemplateName]="specificTemplateName"
      [buttonFunctions]="buttonFunctions"
    ></app-maintenance-templates>
  }
  @case (modules.Profile) {
    <!-- PROFILE related templates -->
    @if (specificTemplateName === profileTableNames.ReadReceipts) {
      <app-read-receipt-template
        [columnName]="columnName"
        [element]="element"
      ></app-read-receipt-template>
    } @else {
      <app-profile-templates
        [specificTemplateName]="specificTemplateName"
        [columnName]="columnName"
        [element]="element"
        [urlForRouting]="urlForRouting"
      ></app-profile-templates>
    }
  }
  @case (modules.Tenant) {
    <app-tenant-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
      [hideButtons]="hideButtons"
      [buttonFunctions]="buttonFunctions"
    ></app-tenant-templates>
  }
  @case (modules.UsersAndPax) {
    <!-- USERS related template -->
    @if (specificTemplateName === profileTableNames.ReadReceipts) {
      <app-read-receipt-template
        [columnName]="columnName"
        [element]="element"
      ></app-read-receipt-template>
    } @else {
      <app-users-template
        [columnName]="columnName"
        [element]="element"
        [buttonFunctions]="buttonFunctions"
        [urlForRouting]="urlForRouting"
      ></app-users-template>
    }
  }
  @case (modules.CrewManagementUser) {
    <!-- CREW-MANAGEMENT-USER related template -->
    <app-crew-management-user-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-crew-management-user-templates>
  }
  @case (modules.OrderAdmin) {
    <!-- ORDER-ADMIN related template -->
    <app-order-admin-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-order-admin-template>
  }
  @case (modules.OrderUser) {
    <!-- ORDER-USER related template -->
    <app-order-user-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-order-user-template>
  }
  @case (modules.ReadReceipts) {
    <app-read-receipt-template
      [columnName]="columnName"
      [element]="element"
    ></app-read-receipt-template>
  }
  @case (modules.RunTime) {
    <!-- RUN-TIME related template -->
    <app-runtime-template [columnName]="columnName" [element]="element"></app-runtime-template>
  }
  @case (modules.DueList) {
    <!-- DUE-LIST related template -->
    <app-due-list-template [columnName]="columnName" [element]="element"></app-due-list-template>
  }
  @case (modules.Medicines) {
    <!-- MEDICINE related template -->
    <app-medicine-template [columnName]="columnName" [element]="element"></app-medicine-template>
  }
  @case (modules.Medicine) {
    <!-- MEDICINE related template -->
    <app-medicine-template [columnName]="columnName" [element]="element"></app-medicine-template>
  }
  @case (modules.Storage) {
    <!-- STORAGE related template -->
    <app-storage-template [columnName]="columnName" [element]="element"></app-storage-template>
  }
  @case (modules.ProductOwnerUsers) {
    <!-- PRODUCT OWNER USERS related template -->
    <app-product-owner-users-template
      [columnName]="columnName"
      [element]="element"
    ></app-product-owner-users-template>
  }
  @case (modules.RiskAssessment) {
    <!-- RISK ASSESSMENT related template -->
    <app-risk-assessments-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-risk-assessments-template>
  }
  @case (modules.RiskAssessments) {
    <!-- RISK ASSESSMENT related template -->
    <app-risk-assessments-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-risk-assessments-template>
  }
  @case (modules.PrivilegeTemplates) {
    <!-- PRIVILEGE TEMPLATES related template -->
    <app-privilege-templates-template
      [columnName]="columnName"
      [element]="element"
    ></app-privilege-templates-template>
  }
  <!-- QUANTITY TYPES related template -->
  @case (modules.QuantityTypes) {
    <app-quantity-types-template
      [columnName]="columnName"
      [element]="element"
    ></app-quantity-types-template>
  }
  @case (modules.WorkAndRest) {
    <!-- WORK AND REST related template -->
    <app-work-and-rest-templates
      [specificTemplateName]="specificTemplateName"
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-work-and-rest-templates>
  }
  @case (modules.MainDashboard) {
    <!-- MAIN DASHBOARD related template -->
    @switch (specificTemplateName) {
      @case ('dashboard-open-reports') {
        <app-non-conformance-template
          [showStatusDotInName]="true"
          [columnName]="columnName"
          [element]="element"
        ></app-non-conformance-template>
      }
      @default {
        {{ element[columnName] }}
      }
    }
  }
  <!-- DEFAULT fallback -->
  @default {
    {{ element[columnName] }}
  }
}
<ng-template #documentTemplates>
  <app-document-templates
    [specificTemplateName]="specificTemplateName"
    [columnName]="columnName"
    [element]="element"
  ></app-document-templates>
</ng-template>
